export default "__VITE_ASSET__7cbe407f__"